import { IconComponent } from 'design-system/types'

export const SparkleIcon: IconComponent = ({ size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 36 36"
    {...props}>
    <g clip-path="url(#clip0_93_10715)">
      <mask
        id="mask0_93_10715"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="36"
        height="36">
        <path d="M36 0H0V36H36V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_93_10715)">
        <path
          d="M18 0C18.6111 9.67673 26.3232 17.3889 36 18C26.3232 18.6111 18.6111 26.3232 18 36C17.3889 26.3232 9.67673 18.6111 0 18C9.67673 17.3889 17.3889 9.67673 18 0Z"
          fill="#2563EB"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_93_10715">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
